if (!customElements.get('theme-pagination')) {
  customElements.define(
    'theme-pagination',
    class ThemePagination extends HTMLElement {
      constructor() {
        super();
        this.type = this.getAttribute('data-type');
        if(this.type == 'paginated') return;
        this.button = this.querySelector('button');
        this.keyword = document.querySelector('#Search-In-Template').value;
        
        this.currentPage = parseInt(this.getAttribute('data-current-page'));
		  	this.nextPage = parseInt(this.getAttribute('data-next-page'));
		  	this.totalPages = parseInt(this.getAttribute('data-total-pages'));
		  	this.section = {
		      id: 'product-grid',
		      section: document.getElementById('product-grid').dataset.id
		    };
      }

      connectedCallback() {
      	if (this.type == 'click') {
	        this.loadMore();
	      } else if (this.type == 'infinite'){
	      	this.loadInfinite();
	      }
      }

      loadInfinite() {
      	this.observer = new IntersectionObserver((entries) =>{
	        if (entries[0].intersectionRatio === 1) this.load();
	      }, {
	        threshold: [0, 1]
	      });
	      this.observer.observe(this);
      }

      loadMore() {
	      this.button.addEventListener('click', (event) => {
	      	event.preventDefault();
	      	this.load(this.button);
	      });
	    }

	    load(triggeredBy) {
	    	if (this.getAttribute('loaded')) return;
	    	if (triggeredBy) this.setActiveElement(triggeredBy);
      	const url = `${window.location.pathname}?q=${this.keyword}&page=${this.nextPage}`;
          console.log(url);
      	const loadingOverlays = document.querySelectorAll(`#LoadingOverlay-${this.section.section}`);
      	[...loadingOverlays].forEach((overlay) => overlay.enableLoading());
      	this.getSectionFromFetch(url);
      	this.updateStatus(triggeredBy);
	    }

	    getSectionFromFetch(url) {
	    	fetch(url)
	        .then(response => response.text())
	        .then((responseText) => {
	          const html = responseText;
	          this.renderSectionFromResult(html);
	          document.dispatchEvent(new CustomEvent('pagination:page-changed'));
	        });
	    }

	    renderSectionFromResult(html) {
		    const loadingOverlays = document.querySelectorAll(`#LoadingOverlay-${this.section.section}`);
	      [...loadingOverlays].forEach((overlay) => overlay.disableLoading());
	      const source = document.getElementById(`${this.section.id}`);
	      const destination = new DOMParser().parseFromString(html, 'text/html').getElementById(`${this.section.id}`);
 
          if(destination) {
            const products = destination.querySelectorAll('.grid__item');
	     	[...products].forEach((product) => source.appendChild(product));
    		source.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));          }
		  }

		  updateStatus() {
		  	if(this.nextPage != this.totalPages){
		  		this.nextPage++;
		  		if (this.activeElement) this.clearActiveElement();
		  	} else {
		  		this.setAttribute('loaded', true);
		  		if (this.activeElement) {
		  			this.activeElement.remove();
		  		} else {
		  			if (this.observer) {
		          this.observer.unobserve(this);
		        }
		  		}
		  	}
		  }

		  setActiveElement(element) {
		    this.activeElement = element;
		    this.activeElement.setAttribute('aria-disabled', true);
            this.activeElement.classList.add('loading');
		  }

		  clearActiveElement() {
		  	this.activeElement.removeAttribute('aria-disabled');
            this.activeElement.classList.remove('loading');
		  }
    }
  );
}